import "abortcontroller-polyfill";

// replaceAll polyfill
// https://vanillajstoolkit.com/polyfills/stringreplaceall/
if (!String.prototype.replaceAll) {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === "[object regexp]") {
      return this.replace(str, newStr);
    }

    // If a string
    return this.replace(new RegExp(str, "g"), newStr);
  };
}

export const abortableFetch = (request, opts) => {
  const controller = new AbortController();
  const signal = controller.signal;

  return {
    abort: () => controller.abort(),
    ready: fetch(request, { ...opts, signal }),
  };
};

export const arrayBufferToBase64 = (buffer) => {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const flatten = (arr) =>
  arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);

export const fetchUrl = async (name) => {
  const res = await fetch(`https://json.edhrec.com/cards/${formatUrl(name)}`);
  const json = await res.json();
  const dir = json.legal_commander ? "commanders" : "cards";
  const url = `/${dir}/${json.url}`;
  return url;
};

export const formatUrl = (str) =>
  str
    .normalize("NFD")
    .toLowerCase()
    .replaceAll(/[^a-zA-Z0-9-_+\s/]/g, "")
    .replaceAll("+", "plus ")
    .replaceAll(/[\s/]+/g, "-");

export const getCardSize = (cardSize) => {
  switch (cardSize) {
    case "xs":
      return { cardSize, height: 170, width: 122 };
    case "sm":
      return { cardSize, height: 255, width: 183 };
    case "lg":
      return { cardSize, height: 425, width: 305 };
    case "xl":
      return { cardSize, height: 510, width: 366 };
    case "md":
    default:
      return { cardSize, height: 340, width: 244 };
  }
};

export const isPatron = (profile) =>
  profile.isAdmin ||
  profile.fakePatronExpires > new Date().toISOString().slice(0, 10) ||
  profile.patreon?.patron_status === "active_patron";

export const isValidEmail = (str) =>
  str.match(
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  );

export const mailtoBugReport = (stack) => {
  if (!stack) return `mailto:bugreport@edhrec.com?subject=Bug%20Report`;
  const body = encodeURIComponent("\n\n--\n\n" + stack);
  return `mailto:bugreport@edhrec.com?subject=Bug%20Report&body=${body}`;
};

export const patronTier = (profile) =>
  profile.isAdmin ? "rare" : profile.patreon?.currently_entitled_amount_cents >= 500 ? "rare" : "uncommon";

export const scrollToTop = () => setTimeout(() => window.scrollTo(0, 0));
